(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('breadcrumb', function(
            broker,
            $route,
            $routeParams,
            basketService,
            analytics,
            breadcrumbDetailsService,
            $timeout) {
    let text;
    if (breadcrumbDetailsService.getText) {
        text = breadcrumbDetailsService.getText();
    }

    //let's optionally get the breadcrumb from the scope so that we can override the route if necessary
    return {
        restrict: 'E',
        replace: true,
        scope: {
            useText: '=',
            showBreadcrumb: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=Breadcrumb',
        link(scope, element) {
            let bc = $route.current.$$route.breadcrumb;
            if (bc && bc.crumb === 10 && TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                bc.crumb = 25;
            }

            const { tripId } = $routeParams;

            if (tripId) {
                basketService.getArea().then(function(a) {
                    const area = scope.area = a;

                    scope.baseAreaUrl = `${TRPCONFIG.Domain.SearchUnitHomePath}${area}`;

                    scope.click = function clickBreadcrumb(c) {
                        /*
                        The number 10 is used to select a flight, and the number 25 is used to change the flight,
                        the names for the crumbs are different, but the functionality is the same,
                        so if the flight was previously chosen, we must use the name of crumbs 25 and the functionality of crumbs 10.
                        This expression was added to avoid code duplication
                        */
                        bc.crumb = basketService.isFlightPreselected() && bc.crumb === 10 ? 25 : bc.crumb;
                        if (c < bc.crumb || (c === bc.crumb)) {
                            analytics.trackEvent({ label: 'breadcrumb nav', value: c });
                            basketService.changeJourneyUrl(c);
                        }
                    };
                    broker.subscribe('breadcrumb', 'ChangeWorkflowState', function(ev) {
                        basketService.changeJourneyUrl(ev.data);
                    });

                    scope.$on('$destroy', () => {
                        broker.unsubscribe('breadcrumb');
                    });
                });
            }

            scope.show = bc != null;

            if (bc != null) {
                breadcrumbDetailsService.getCrumbs(scope.useText).then(function(crumbs) {
                    scope.crumbs = crumbs;
                    scope.width = function() {
                        return { width: `${100 / scope.crumbs.length}%` };
                    };
                });
                scope.class = breadcrumbDetailsService.getClasses(bc, scope.useText);
                if (text) {
                    scope.text = function(c) {
                        return text[c];
                    };
                }
            }

            scope.shortText = function(crumb) {
                return breadcrumbDetailsService.getTextShort()[crumb];
            };

            $timeout(() => {
                const wrapperClass = 'breadcrumb-wrapper';
                const wrapper = element.hasClass(wrapperClass) ? element : element.find(`.${wrapperClass}`);
                const activeCrumb = element.find('.is-active');
                const wrapperOffsetLeft = _.get(wrapper, '[0].offsetLeft');
                const crumbsOffsetLeft = _.get(activeCrumb, '[0].offsetLeft');
                const offsetPosition = crumbsOffsetLeft - wrapperOffsetLeft;

                if (crumbsOffsetLeft && offsetPosition) {
                    wrapper[0].scrollLeft = offsetPosition;
                }
            }, 1000);
        }
    };
});
})();
